import { render, staticRenderFns } from "./GoodieComponent.vue?vue&type=template&id=074335c7"
import script from "./GoodieComponent.vue?vue&type=script&lang=js"
export * from "./GoodieComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports